import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest, obj=auth

  useEffect(() => {
    // Returning from Google OAuth? Let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    const token = localStorage.getItem("pq_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("pq_token");
        setUser(null);
      });
  }, []);

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("pq_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pq_token", data.token);
    setUser(data.user);
  };

  const completeGoogleLogin = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    localStorage.setItem("pq_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pq_token");
    localStorage.removeItem("pq_profile");
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, register, login, completeGoogleLogin, logout, refresh, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
